import { createSelector } from 'reselect';

/* eslint-disable import/prefer-default-export */

export const getOrderStatus = (state) => state.order.status;

export const getMissedCallModal = createSelector(
  [getOrderStatus],
  (orderStatus) => orderStatus && orderStatus.missedCallModal,
);

export const getFulfillmentType = createSelector(
  [getOrderStatus],
  (orderStatus) => orderStatus && orderStatus.fulfillmentType,
);
